module.exports = __webpack_public_path__ + "static/vincit-d0032e6dec64f2e3e95c9642c1339be8.svg";